// Import 3rd-party dependencies
import { Component } from '@angular/core';
import { interval } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

// Import project-specific dependencies
import { NewsService } from '@app/services/news/news.service';
import { LATEST_NEWS_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-latest-news',
  templateUrl: './latest-news.component.html',
  styleUrls: ['./latest-news.component.css']
})
export class LatestNewsComponent {
  consts = LATEST_NEWS_COMPONENT_CONSTS;

  latestNews$ = interval(this.consts.POLL_INTERVAL).pipe(
    startWith(0),
    switchMap(() => this.newsService.allNews$)
  );

  constructor(private newsService: NewsService) {}
}
